const ctx = require.context('.', true, /\.jpg$/);

const pathDirectoryRegex = /^\.\/([a-z]{1,2})\//i;
let images = ctx.keys().reduce((images, path) => {
    let match = pathDirectoryRegex.exec(path);
    if (!match) {
        return images;
    }

    let existing = images[match[1]] || {};
    existing[path] = ctx(path);
    images[match[1]] = existing;

    return images;
}, {});

images = Object.keys(images).reduce((images, letter) => {
    let paths = Object.keys(images[letter]);
    paths.sort();

    images[letter.toUpperCase()] = paths.map((path) => images[letter][path]);
    delete images[letter];
    return images;
}, images);

export default images;


// WEBPACK FOOTER //
// ./src/assets/img/gallery/index.js